import { Home, Bug, Leaf, Wallet } from 'lucide-react';
import SpiracleLogo from '../../img/spiracle_logo.png';
import CTA from '../Cta';

function OvenMicrowaveRepairService() {
    return (
        <div className="chimney-repair-container">
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">General Pest Control Services</h1>
                    <p className="chimney-repair-subtitle">
                        Complete pest management for all crawling and flying pests that trouble your home or business - from ants and spiders to cockroaches, silverfish and more.
                    </p>
                    <p className="chimney-repair-subtitle">
                        We act on the root cause of the problem rather than just the symptoms, with a safety first approach using best in class environmentally safe active ingredients.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Our trained and experienced staff focuses on preventive measures rather than curative measures, so your premises stay pest free for longer.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Every service includes a clear explanation of the pre and post service requisites to the customer.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:8530352444")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={SpiracleLogo} alt="General Pest Control" />
            </div>

            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our General Pest Control?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Bug size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Complete Coverage</h3>
                            <p className="chimney-repair-description">
                                All crawling and flying pests treated in a single professional service.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Leaf size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Eco-friendly</h3>
                            <p className="chimney-repair-description">
                                Best in class environmentally safe active ingredients for your family.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Home size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Prevention First</h3>
                            <p className="chimney-repair-description">
                                Focus on preventive measures rather than curative measures.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Wallet size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Cost Effective</h3>
                            <p className="chimney-repair-description">
                                Professional pest management at a pocket friendly price.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our General Pest Control Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Pest Survey</h3>
                        <p className="chimney-repair-step-description">
                            Identify the pest species and the root cause of the infestation.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Strategy</h3>
                        <p className="chimney-repair-step-description">
                            We make a pest control strategy using technological advancement and training.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Treatment</h3>
                        <p className="chimney-repair-step-description">
                            Safe and effective treatment applied by trained, experienced staff.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Guidance</h3>
                        <p className="chimney-repair-step-description">
                            Pre and post service requisites explained clearly to the customer.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default OvenMicrowaveRepairService;